export default {
    pnocl: '',
    pnlot: '',
    fmod: '',
    ftail: '',
    launch_research: false,
    reset_rate_list: false,
};